import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const BloodConsumptionCardPage = lazy(
  () => import('@/pages/blood-consumption/ui/BloodConsumptionCardPage'),
)

export const Route = createFileRoute(
  '/_protected/recipients/blood-consumption/$protocolId',
)({
  component: () => (
    <Suspense fallback={<Loader />}>
      <BloodConsumptionCardPage />
    </Suspense>
  ),
})
